import { IsValidProp } from '../helper.service'

const controllerName = 'projects'

function Get(id) {
  return window.axios.get(`api/${controllerName}/${id}`)
}

function GetAll(type, currentPage, recordsPerPage, search) {
  const params = {
    'isActive.Operator': 4,
    'isActive.Value': true,
    'type.Operator': 4,
    'type.Value': type,
    'sort[0][field]': 'isPinned',
    'sort[0][dir]': 'desc',
    'sort[1][field]': 'createdAt',
    'sort[1][dir]': 'desc',
    pageNo: currentPage,
    recordsPerPage: recordsPerPage
  }

  if (search) {
    params['title.Operator'] = 7
    params['title.Value'] = search
  }

  return window.axios.get(`api/${controllerName}`, { params })
}

function GetAllPublic(type, currentPage, recordsPerPage, search) {
  const params = {
    'isActive.Operator': 4,
    'isActive.Value': true,
    'type.Operator': 4,
    'type.Value': type,
    'sort[0][field]': 'isPinned',
    'sort[0][dir]': 'desc',
    'sort[1][field]': 'createdAt',
    'sort[1][dir]': 'desc',
    pageNo: currentPage,
    recordsPerPage: recordsPerPage
  }

  if (search) {
    params['title.Operator'] = 7
    params['title.Value'] = search
  }

  return window.axios.get(`api/${controllerName}/public/access`, { params })
}

function Put(id, formModel) {
  const formData = new FormData()
  for (const key in formModel) {
    const mainObj = this.formModel[key]
    if (key === 'removedImageIds') {
      if (IsValidProp(mainObj)) {
        mainObj.forEach((element, removedIndex) => {
          formData.append(`${key}[${removedIndex}]`, element)
        })
      }
    } else if (key === 'projectImages') {
      if (IsValidProp(mainObj)) {
        mainObj.forEach((image, imageIndex) => {
          if (image.isNew) {
            formData.append(`${key}`, image.file)
          }
        })
      }
    } else if (IsValidProp(formModel[key])) {
      formData.append(key, formModel[key] == null ? '' : formModel[key])
    }
  }

  return window.axios.put(`api/${controllerName}/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data;'
    }
  })
}

function Post(formModel) {
  const formData = new FormData()
  for (const key in formModel) {
    const mainObj = this.formModel[key]
    if (key === 'projectImages') {
      if (IsValidProp(mainObj)) {
        mainObj.forEach((image, imageIndex) => {
          if (image.isNew) {
            formData.append(`${key}`, image.file)
          }
        })
      }
    } else if (IsValidProp(formModel[key])) {
      formData.append(key, formModel[key] == null ? '' : formModel[key])
    }
  }

  return window.axios.post(`api/${controllerName}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data;'
    }
  })
}

export { Get, GetAll, GetAllPublic, Put, Post }
